export default __webpack_public_path__ + "static/media/insurance_workers.4e896779.png";